//fonte de dados da acao de ia, igual ao iaConfiguracaoAcaoFonte do back
export enum IaConfiguracaoAcaoFonteEnum {
  NENHUMA = 1,
  INTERNET = 2,
  BASE_CONHECIMENTO = 3
}
